// A section's nav entry (routes/<Section>.nav.ts), collected by shell/nav.ts. Kept apart from nav.ts
// so the entry files do not import the module that collects them.
import type { ComponentType } from 'react';
import type { NavItem } from './nav';

/** Where the section sits (`order`, ascending; leave gaps) and its page's loader (a lazy chunk). */
export interface NavEntry extends NavItem {
  order: number;
  load: () => Promise<{ default: ComponentType }>;
}

export const defineNav = (e: NavEntry): NavEntry => e;
